import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { getOverviewTrans } from "../service";

export const useGetOverview = (params, options) => {
  return useQuery(
    [queryKey.HOME_OVERVIEW, params],
    () => getOverviewTrans({ ...params }).then((res) => res.data.data),
    {
      ...options,
    }
  );
};
